import axios from "../axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "../config";


export const GetCandidateDetails = async (submitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post(
    "/api/Candidate/GetCandidateDetails",
    {
      token,
      submitedCandidateUID,
    },
    {
      validateStatus: () => true
    }
  );
};

export const GetCandidateInterviewDetails = async (submitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  try {
    // First API: Candidate Interview Details
    const interviewDetailsRes = await axios.post(
      "/api/Candidate/GetCandidateInterviewDetails",
      { token, submitedCandidateUID },
      { validateStatus: () => true }
    );

    // Second API: Candidate Interview Feedback Details
    const feedbackRes = await axios.post(
      "/api/Candidate/GetInterviewFeedbackDetails",
      { 
        token, 
        submissionUID: submitedCandidateUID 
      },
      { validateStatus: () => true }
    );

    // Combine results into one object
    return {
      interviewDetails: interviewDetailsRes.data,
      feedbackDetails: feedbackRes.data,
    };

  } catch (error) {
    return {
      interviewDetails: [],
      feedbackDetails: [],
      error: true,
    };
  }
};

export const GetAllReceivedCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetAllReceivedCandidates", {
    token,
  });
};

export const GetAllShortlistCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetShortlistedCandidate", {
    token,
  });
};

export const ShortlistCandidate = async (
  SubmitedCandidateUID,
  Status,
  Remark
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/ShortlistCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

export const InterviewSchedule = async (
  SubmitedCandidateUID,
  Status,
  Remark,
  FirstInterviewDateTime,
  InterviewerList
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/ScheduleInterview", {
    token: token,
    status: Status,
    submitedCandidateUID: SubmitedCandidateUID,
    remark: Remark,
    firstInterviewDateTime: FirstInterviewDateTime,
    interviewerList: InterviewerList.map((i) => ({
      interviewerCode: i.interviewerCode,
      interviewSequence: i.interviewSequence,
    })),
  });
};

export const GetAllInterviewScheduleCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetInterviewScheduledCandidates", {
    token,
  });
};

//Harshada Bhavsar: 26/7/2025
//Selected Candidate and Get Selected Candidate for Employee
export const SelectedCandidate = async (
  SubmitedCandidateUID,
  Status,
  Remark
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/SelectCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

export const GetSelectedCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetSelectedCandidates", {
    token,
  });
};

// Harshada Bhavsar: 29/7/2025
// Rejected Candidate

export const RejectedCandidates = async (
  SubmitedCandidateUID,
  Status,
  Remark
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/RejectCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

//Get All Rejected Candidates
export const GetAllRejectedCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetRejectedCandidates", {
    token,
  });
};

// Harshada Bhavsar: 07/08/2025
// Hold Candidate

export const HoldCandidates = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/HoldCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

//Get Hold Candidate
export const GetAllHoldCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetHoldCandidates", {
    token,
  });
};

// Harshada Bhavsar: 07/08/2025
// Start Background Verification

export const StartBGV = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/StartBGVCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

//Get All BGV  Candidate
export const GetAllBGVCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetBGVCandidates", {
    token,
  });
};

// Harshada Bhavsar: 07/08/2025
// Start Background Verification

export const SendAssessmentCandidate = async (
  SubmitedCandidateUID,
  Status,
  Remark,
  AssessmentLink
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/SendAssessmentCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
    AssessmentLink,
  });
};

//Get All BGV  Candidate
export const GetAssessmentCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetAssessmentCandidates", {
    token,
  });
};

// Harshada Bhavsar : 08/08/2025
// Get System Remarks
export const SystemRemark = async (SubmitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetSystemRemark", {
    token,
    SubmitedCandidateUID,
  });
};

//Harshada Bhavsar: 24/7/2025
//Consultant Shortlisted Candidate
export const CGetAllShortlistCandidates = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("api/Consultant/GetShortlistedCandidate", {
    token,
  });
};

//Harshada Bhavsar: 25/7/2025
//Consultant Get Interview Scheduled Candidate
export const CGetInterviewSchedule = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetInterviewScheduledCandidates", {
    token,
  });
};

//Harshada Bhavsar: 25/7/2025
export const CGetSelectedCandidate = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetSelectedCandidates", {
    token,
  });
};

// Harshdada Bhavsar : 30/7/2025
// View Resume API For Employee
// export const viewResumeUrl = (resumePath) => {
//   const token = Cookies.get("employeeToken");
//   return axios.get(`/api/Metadata/${encodeURIComponent(resumePath)}/${token}`);
// };

// View Resume API For Employee
export const viewResumeUrl = (resumePath) => {
  const token = Cookies.get("employeeToken");
  return `${API_BASE_URL}/api/Metadata/${encodeURIComponent(
    resumePath
  )}/${token}`;
};

// Harshdada Bhavsar : 30/7/2025
// View Resume API For Consultant
export const viewResume = (resumePath) => {
  const token = Cookies.get("ConsultantToken");
  return `${API_BASE_URL}/api/Metadata/${encodeURIComponent(
    resumePath
  )}/${token}`;
};

//Harshada Bhavsar : 11/09/2025
//Schedule Next Interview
export const ScheduleNextInterview = async (interviewUID, interviewDate) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/ScheduleNextInterview", {
    token: token,
    interviewUID: interviewUID,
    interviewDate: interviewDate,
  });
};



// Harshada Bhavsar: 16/12/2025
// Offer Released Candidate

export const OfferReleseCandidate = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/OfferReleseCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 16/12/2025
//Get  Offer Released Candidate
export const GetAllOfferReleasedCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetOfferRelesedCandidates", {
    token,
  });
};

// Harshada Bhavsar: 16/12/2025
// BackOut Candidate

export const BackOutCandidate = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/BackOutCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 17/12/2025
//Get Back-out Candidate
export const GetAllBackOutCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetBackOutCandidates", {
    token,
  });
};


// Harshada Bhavsar: 17/12/2025
// Hire Candidate

export const HireCandidate = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/HireCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 17/12/2025
//Get Hired Candidate
export const GetAllHiredCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetHiredCandidates", {
    token,
  });
};